/**
 * Check if an element is in the viewport.
 *
 * @param {Bound} boundaryObject - Boundary object of a HTML element.
 * @returns {boolean} True if the element is in the viewport.
 */
export var isInViewport = function (_a) {
    var top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
    return top >= 0 &&
        left >= 0 &&
        bottom <= window.innerHeight &&
        right <= window.innerWidth;
};
